import React, { useState, useEffect } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import PayrollSummary from "./PayrollSummary";
import PayrollSalary from "./RunPayroll";
import RunPayroll from "./RunPayroll";
import AdvancePayroll from "./AdvancePayroll";
import PayrollIncentives from "./PayrollIncentives";
import PayrollReimbrusments from "./PayrollReimbrusments";
import PaymentHistory from "./PaymentHistory";
import { useGlobalContext } from "../../../Context/GlobalContext";
import { useSearchParams } from "react-router-dom";


const PayrollMenu = ({
  toggleRunTab,
  setToggleRunTab,
  
}) => {
  const { selectedTab, setSelectedTab, activeSubmenu, setActiveSubmenu } =
    useGlobalContext();

    const [searchParams , setSearchParams] = useSearchParams();
      const activeTab = Number(searchParams.get("tab")) || 0; 


  useEffect(() => {
    if (!activeSubmenu) {
      setActiveSubmenu(true);
    }
  }, []);
    // Update selectedTab state when the tab query parameter changes
    useEffect(() => {
      setSelectedTab(activeTab); 
    }, [activeTab]);

    const handleTabSelect = (index) => {
      setSelectedTab(index); // Update the state
      setSearchParams({ tab: index }); // Update the URL
    };
    

  console.log(selectedTab);

  return (
    <div className="staff-menu payroll-menus p-[20px] mb-[14px]">
      <h3 className="text-[20px]  font-[Poppins]">Pay Roll</h3>

      <div className="tab-section mt-[30px]">
        <Tabs
          selectedIndex={selectedTab} 
          onSelect={handleTabSelect} 
        >
          <TabList className="flex   w-[100%] overflow-x-scroll bg-[#FFFFFF]  rounded-[12px] pt-[4px] p-[10px] pb-[4px]  set-shadow ">
            <Tab  
            className={`${
                activeTab === 0
                  ? "react-tabs__tab  react-tabs__tab--selected"
                  : "text-[#B1B1B1] react-tabs__tab"
              }`}
              >
              <div className="flex items-center  whitespace-nowrap mr-[20px]">
                <h2 className="text-sm text-[#B1B1B1]  ml-[15px]">
                  Payroll Summary
                </h2>
              </div>
            </Tab>
            <Tab 
            className={`${
                activeTab === 1
                  ? "react-tabs__tab  react-tabs__tab--selected"
                  : "text-[#B1B1B1] react-tabs__tab"
              }`} >
              <div className="flex items-center  whitespace-nowrap mr-[20px]">
                <h2 className="text-sm text-[#B1B1B1]  ml-[15px]">
                  Run Payroll
                </h2>
              </div>
            </Tab>
            <Tab 
            className={`${
                activeTab === 2
                  ? "react-tabs__tab  react-tabs__tab--selected"
                  : "text-[#B1B1B1] react-tabs__tab"
              }`}  >
              <div className="flex items-center  whitespace-nowrap mr-[20px]">
                <h2 className="text-sm text-[#B1B1B1]  ml-[15px]">Advance</h2>
              </div>
            </Tab>
            <Tab 
            className={`${
                activeTab === 3
                  ? " react-tabs__tab react-tabs__tab--selected"
                  : "text-[#B1B1B1] react-tabs__tab"
              }`}  
              >
              <div className="flex items-center  whitespace-nowrap mr-[20px]">
                <h2 className="text-sm text-[#B1B1B1]  ml-[15px]">
                  Incentives
                </h2>
              </div>
            </Tab>
            <Tab 
            className={`${
                activeTab === 4
                  ? "react-tabs__tab react-tabs__tab--selected"
                  : "text-[#B1B1B1] react-tabs__tab"
              }`}  >
              <div className="flex items-center whitespace-nowrap mr-[20px]">
                <h2 className="text-sm text-[#B1B1B1]  ml-[15px]">
                  Reimbrusments
                </h2>
              </div>
            </Tab>

            <Tab 
            className={`${
                activeTab === 5
                  ? "react-tabs__tab  react-tabs__tab--selected"
                  : "text-[#B1B1B1] react-tabs__tab"
              }`} >
              <div className="flex items-center  whitespace-nowrap mr-[20px]">
                <h2 className="text-sm text-[#B1B1B1]  ml-[15px]">
                  Payment History
                </h2>
              </div>
            </Tab>
          </TabList>

          <TabPanel>
            <PayrollSummary />
          </TabPanel>

          <TabPanel>
            <RunPayroll  />
          </TabPanel>

          <TabPanel>
            <AdvancePayroll />
          </TabPanel>

          <TabPanel>
            <PayrollIncentives />
          </TabPanel>

          <TabPanel>
            <PayrollReimbrusments />
          </TabPanel>

          <TabPanel>
            <PaymentHistory />
          </TabPanel>
        </Tabs>
      </div>
    </div>
  );
};

export default PayrollMenu;
